import { useState } from "react";
import Button from "../../../components/Button";

const Form = ({inputs, sendData}) => {
    const [texts, setTexts] = useState(Array(inputs.length).fill(""));
    const [error_matrix, setErrorMatrix] = useState(Array(inputs.length).fill([]));

    const noErrors = (errors) => {
        for (let i_errors of errors) {
            if (i_errors.length !== 0) {
                return false;
            }
        }
        return true;
    }

    const submit = (event) => {
        event.preventDefault();

        let errors = [];

        for (let i = 0; i < inputs.length; i++) {
            let i_errors = [];
            for (let req of inputs[i].reqs) {
                const splits = req.split(" ");
                switch(splits[0]) {
                    case "min":
                        if (texts[i].length < parseInt(splits[1])) {
                            i_errors.push(`Should be at least ${splits[1]} characters long`);
                        }
                        break;
                    case "max":
                        if (texts[i].length > parseInt(splits[1])) {
                            i_errors.push(`Should be less than ${splits[1]} characters long`);
                        }
                        break;
                    case "maxbytes":
                        if (new TextEncoder().encode(texts[i]).length > parseInt(splits[1])) {
                            i_errors.push(`Should be at most ${splits[1]} bytes long`);
                        }
                        break;
                    case "upper":
                        if (!/[A-Z]/.test(texts[i])) {
                            i_errors.push(`Should include uppercase letters`);
                        }
                        break;
                    case "lower":
                        if (!/[a-z]/.test(texts[i])) {
                            i_errors.push(`Should include lowercase letters`);
                        }
                        break;
                    case "num":
                        if (!/[0-9]/.test(texts[i])) {
                            i_errors.push(`Should include numbers`);
                        }
                        break;
                    case "confirm":
                        if (texts[i] !== texts[inputs.findIndex(input => input.name === splits[1])]) {
                            i_errors.push("Does not match");
                        }
                        break;
                }
            }
            errors.push(i_errors);
        }

        if (noErrors(errors)) {
            sendData(texts);
        } else {
            setErrorMatrix(errors);
        }
    }
    
    const updateTexts = (i, text) => {
        let newTexts = [...texts];
        newTexts[i] = text;
        setTexts(newTexts);
    }

    const types = inputs.map(input => input.isPassword ? "password" : "text");

    return <form className="flex flex-col gap-4" onSubmit={submit}>
        {inputs.map((input, i) => <div className="flex flex-col gap-1" key={input.name}>
            <label className="account-label" htmlFor={input.name}>{input.placeholder}</label>
            <input
                id={input.name}
                className="form-field"
                type={types[i]}
                placeholder={input.placeholder}
                onChange={e => updateTexts(i, e.target.value)}
            />
            {error_matrix[i].map((error, errorIndex) => <div className="text-sm font-semibold text-red-600" key={`${input.name}-${errorIndex}`}>
                {error}
            </div>)}
        </div>)}
        <Button text="Reset password" type="submit" />
    </form>
}

export default Form;
